import { render } from "./About.vue?vue&type=template&id=ba209176"
const script = {}
script.render = render

export default script